/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @stylistic/no-mixed-operators */
/* eslint-disable camelcase */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';

import CouponInput from '../../Parts/CouponInput';
import Money from '../../Parts/Money';
import { useQuoteAccessories } from '../../Store/entities/accessories/hooks';
import { useQuoteAwnings } from '../../Store/entities/awnings/hooks';
import { useQuoteFabricSamplesByQuoteId } from '../../Store/entities/fabricSamples/hooks';
import { useAssembliesByQuoteId } from '../../Store/entities/assemblies/hooks';
import apiCalls from '../../PowerShadesAPIFunctions';
import { UseMultipliersByQuoteId, useQuoteById, useQuotePricing, useQuoteTypeNameByQuoteId } from '../../Store/entities/quotes/hooks';
import { useHWRItemsByQuoteId } from '../../Store/entities/hardwareRequestItems/hooks';
import { useQuoteDemoReview } from '../../Store/entities/quoteDemoReviews/hooks';
import { UsePortalDispatch } from '../../Store';
import { RefreshQuotePricing } from '../../Store/entities/quotes';
import getEffectivePricingMultiplier from '../pricingContext';

type CouponInfoProps = {
	hideDeleteButtons: boolean;
	onCouponChange: (coupons: any) => void;
	quoteId: number;
	couponCode: string;
};

export const CouponInfo = ({ couponCode, hideDeleteButtons, onCouponChange, quoteId }: CouponInfoProps) => {
	const dispatch = UsePortalDispatch();
	return (couponCode === "" ? null : (

		<div
			style={{
				display: 'flex', flexDirection: 'column', alignItems: 'right'
			}}
		>
			<span
				key={couponCode}
				style={{
					backgroundColor: '#ffff90',
					padding: '0.5em',
					display: 'inline-flex',
					flexDirection: 'row',
					justifyContent: 'space-between'
				}}
			>
				<span style={{ fontWeight: 'normal' }}>
					Coupon:&nbsp;&nbsp;
					{couponCode}
				</span>
				{
					hideDeleteButtons

						? null
						: (
							<button
								style={{ backgroundColor: 'transparent', border: 'none' }}
								onClick={() => {
									// const coupons = quote.addCoupon(null, () => { onCouponChange([]); });
									apiCalls.addCouponToQuote(couponCode, quoteId, true, "Submitted by Customer")
										.then((_) => {
											onCouponChange([]);
										}).then(() => {
											dispatch(RefreshQuotePricing({ quoteId }));
										});
								}}
							>
								x
							</button>
						)
				}
			</span>
		</div>

	));

}

const OrderPriceSummaryAccessoryRow = ({ accessory, multiplier }) => (
	<tr>

		<td>{accessory.quantity}</td>
		<td>{accessory.name}</td>
		<td>
			<Money>
				{accessory.msrp * multiplier.currency_multiplier * multiplier.multiplier}
			</Money>
		</td>

	</tr>
);

type NewOrderPriceSummaryTableProps = {
	quoteId: number;
};

const NewOrderPriceSummaryTable = ({ quoteId }: NewOrderPriceSummaryTableProps) => {
	const fabricSamples = useQuoteFabricSamplesByQuoteId(quoteId);
	const fabric_sample_count = fabricSamples.length;

	// const pricingNew = useQuoteById(quoteId);

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const assemblies = useAssembliesByQuoteId(quoteId);
	// const qas = useQuoteAccessories(quoteId);
	// const hwrItems = useHWRItemsByQuoteId(quoteId);
	// const shadeCount = assemblies.length;
	const quoteAcc = useQuoteAccessories(quoteId);
	const quote = useQuoteById(quoteId);

	const awnings = useQuoteAwnings(quoteId);
	const isAwningQuote = (quote?.product_category ?? 'roller_shades') === 'awnings';

	const multipliers = UseMultipliersByQuoteId(quoteId);
	const show_my_price = getEffectivePricingMultiplier({
		dealerId: quote?.dealer_id,
		distributorId: quote?.distributor_id,
		multipliers,
	});

	const quoteAccessories = useQuoteAccessories(quoteId);

	const [, setCouponState] = useState<null | "active" | "deleting">(null);

	const localQuoteTotals = useQuotePricing(quoteId, show_my_price.multiplier, show_my_price.currency_multiplier);
	
	const msrpQuoteTotals = useQuotePricing(quoteId, 1, show_my_price.currency_multiplier);

	const acc_rows = quoteAccessories
		.filter((acc) => acc.quantity > 0)
		.map((acc) => (
			<OrderPriceSummaryAccessoryRow
				key={acc.Id}
				accessory={acc}
				multiplier={{
					multiplier: show_my_price.multiplier,
					currency_multiplier: show_my_price.currency_multiplier
				}}
			/>
		));

	const total_awnings_price = localQuoteTotals?.awnings_price ?? 0;
	const total_awnings_shipping_price = localQuoteTotals?.awning_shipping_price ?? 0;

	// Awning shipping is rolled into freight, so pull it back out when it gets its own line.
	const total_oversized_fees = (localQuoteTotals?.freight_shipping_price ?? 0)
		- (isAwningQuote ? total_awnings_shipping_price : 0);
	// const total_outdoor_shades_shipping_price = localQuoteTotals?.freight_shipping_price ?? 0;

	const total_amount_coupon = localQuoteTotals?.coupon_total ?? 0;

	const total_shades_shipping_price = localQuoteTotals?.assembly_shipping_price;

	const total_accessories_shipping_price = localQuoteTotals?.accessory_shipping_price ?? 0;
	const hwItems = useHWRItemsByQuoteId(quoteId);
	const hwItemDisplay = localQuoteTotals?.hardware_price;

	let hwItemShipping = localQuoteTotals?.hardware_shipping_price ?? 0;
	if (assemblies.length === 0 && hwItems.length > 0 && quoteAcc.length === 0) {
		hwItemShipping = quote.shipping_snapshot * show_my_price.currency_multiplier;
	}

	let priceTitle = "My Price";

	if (show_my_price.currency_multiplier != 0) {
		priceTitle += ` (${show_my_price.currency})`;
	}

	const displyPrice = (localQuoteTotals?.subtotal ?? 0) - total_amount_coupon;;

	const assemblyPrice = localQuoteTotals?.assembly_price ?? 0;

	const displayBeforeCoupon = localQuoteTotals?.subtotal;

	const taxes = localQuoteTotals?.total_taxes ?? 0;

	const putLine = displayBeforeCoupon !== displyPrice && taxes > 0;

	const demoInfo = useQuoteDemoReview(quoteId);

	const isDemo = quoteType?.toLocaleLowerCase() === 'demo';

	let newDisplayTotalPrice = 0;

	let demoDiscount = 0;

	if (isDemo && localQuoteTotals) {
		let multipliableMsrp = (msrpQuoteTotals?.subtotal ?? 0) - (localQuoteTotals?.total_shipping_price ?? 0);
		newDisplayTotalPrice = demoInfo?.name !== 'cash'
			? multipliableMsrp * (1 - (demoInfo?.value ?? 0) / 100)
			: demoInfo.value ?? 0;
		newDisplayTotalPrice += localQuoteTotals?.total_shipping_price ?? 0;
		demoDiscount = (localQuoteTotals?.subtotal ?? 0) - newDisplayTotalPrice;
	}

	return (

		<div>

			<table className={`order-confirmation-table ${quoteType}`} border={0} cellSpacing="0" cellPadding="0">
				<tbody>

					<tr className="bold-row">
						<th>Qty</th>
						<th>Product</th>
						<th>{priceTitle}</th>
					</tr>

					<tr>

						<td>{isAwningQuote ? awnings.length : assemblies.length}</td>

						<td>{isAwningQuote ? 'Awnings' : 'Shades'}</td>

						<td>
							<Money>{isAwningQuote ? total_awnings_price : assemblyPrice}</Money>
						</td>

					</tr>

					<tr>

						<td>1</td>

						<td>{isAwningQuote ? 'Awnings Shipping' : 'Shades Shipping'}</td>

						<td>
							<Money>
								{isAwningQuote ? total_awnings_shipping_price : total_shades_shipping_price}
							</Money>
						</td>

					</tr>

					{acc_rows}

					{
						total_accessories_shipping_price

							? (
								<tr>

									<td>1</td>

									<td>Accessories Shipping</td>

									<td>
										<Money>{total_accessories_shipping_price}</Money>
									</td>

								</tr>
							)
							: null
					}

					{
						total_oversized_fees > 0
							? (
								<tr>
									<td>1</td>
									<td>Oversized Shipping Fee</td>
									<td>
										<Money>{total_oversized_fees}</Money>
									</td>
								</tr>
							)
							: null
					}


					{
						(hwItemDisplay ?? 0) > 0 ? (
							[
								<tr>
									<td>1</td>
									<td>Hardware Request Items</td>
									<td>
										<Money>{hwItemDisplay}</Money>
									</td>
								</tr>,
								<tr>
									<td>1</td>
									<td>Hardware Request Shipping</td>
									<td>
										<Money>{hwItemShipping}</Money>
									</td>
								</tr>
							]
						) : null
					}

					{
						fabric_sample_count > 0
							? (
								<tr>
									<td>{fabric_sample_count}</td>
									<td>Fabric Samples</td>
									<td><Money>{0}</Money></td>
								</tr>
							)
							: null
					}
					{
						(taxes > 0 && (localQuoteTotals?.total_taxable_amount ?? 0) > 0) && 
						(
							<tr>
								<td>1</td>
								<td>Taxes</td>
								<td><Money>{taxes}</Money></td>
							</tr>
						)
					}

				</tbody>
			</table>

			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<div style={{ flexGrow: '1' }}>

					{
						!isDemo
							? (
								<CouponInput
									quoteId={quoteId}
									onCouponChange={(_) => {
										setCouponState("active");
									}}
								/>
							)
							: null
					}

					<div style={{ width: '100%', height: '9px' }} />

					<CouponInfo
						hideDeleteButtons={!(!isDemo)}
						couponCode={quote.coupon_name ?? ''}
						onCouponChange={(_) => {
							setCouponState("deleting");
						}}
						quoteId={quote?.id}
					/>
				</div>

				<div
					style={{
						display: 'flex', flexDirection: 'column', textAlign: 'right', marginLeft: '2.25em'
					}}
				>

					{
						total_amount_coupon
							? (
								<>
									<span>
										{total_amount_coupon ? '' : 'Total'}
										Price:&nbsp;&nbsp;
										<Money>{displayBeforeCoupon}</Money>
									</span>

									<span>
										Discount:&nbsp;&nbsp;
										<span style={{ color: 'red' }}>
											-
											<Money>{total_amount_coupon}</Money>
										</span>
									</span>

								</>
							)
							: null
					}

					{/* {(taxes > 0)
						? (
							<span style={{ flexGrow: '1' }}>
								<div>
									Subtotal:
									{' '}
									<Money>{localQuoteTotals?.total_taxable_amount}</Money>
								</div>

								<div>
									Taxes :
									{' '}
									<Money>{taxes}</Money>
								</div>
							</span>
						)
						: null} */}

					{
						putLine ? <hr style={{ width: '100%' }} /> : null
					}

					<span className="total-price-text right-align">
						Total:&nbsp;&nbsp;
						<Money>{displyPrice}</Money>
					</span>
					{isDemo ? (
						<>
							<span className="total-price-text right-align">
								Demo Discount:&nbsp;&nbsp;
								<Money>{demoDiscount}</Money>
							</span>
							<span className="total-price-text right-align">
								Demo Total:&nbsp;&nbsp;
								<Money>{newDisplayTotalPrice}</Money>
							</span>
						</>
					) : null}
				</div>

			</div>

		</div>
	);
};

export default NewOrderPriceSummaryTable;
